import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatDwellTime, isDwellOverThreshold } from "@/lib/dwell-time";

interface DwellTimeChipProps {
  /** ISO timestamp of the most recent check-in event. */
  occurredAt: string;
  className?: string;
}

/**
 * Chip displaying trailer dwell time since the last check-in.
 * Uses Aurora tokens via the `.status-badge` system: error variant when
 * dwell exceeds the 24h threshold, neutral otherwise.
 */
export function DwellTimeChip({ occurredAt, className }: DwellTimeChipProps) {
  const overThreshold = isDwellOverThreshold(occurredAt);
  return (
    <span
      className={cn(
        "status-badge gap-1",
        overThreshold ? "status-error" : "status-neutral",
        className,
      )}
    >
      <Clock className="h-3 w-3" />
      {formatDwellTime(occurredAt)}
    </span>
  );
}
